export default {
  name: 'Macedonia',
  phonePattern: '072345678',
  postalCodePattern: '1111',
  singlePostalCode: '',
  postalCodeRegex: '^[\\d]{4}$',
  language: '',
  dobFormat: 'DD.MM.YY'
}



// WEBPACK FOOTER //
// ./src/locales/countries/MK.js